import { createContext, useContext, useRef, useState } from "react";
import { CenterPanelContext } from "../..";
import { useAppSelector } from "../../../../../../redux";
import { getIsARepost } from "../../../../../../utils";
import { PostCardProps } from "../PostCard";
import { ReportPost } from "../ReportPost";
import { DefaultPostCardContentView } from "./DefaultPostCardContentView";
import { ExpandedPostCardContentView } from "./ExpandedPostCardContentView";

const PostCardContext = createContext({} as PostCardProps.Context);
export const usePostCardContext = () => useContext(PostCardContext);
export const PostCardContent = ({
  postId,
  isWithinRepostModal = false,
  isWithinRepostPost = false,
  isOnExpandedPostView = false,
}: PostCardProps.PostCardContent) => {
  const [showPostCardOptions, setShowPostCardOptions] = useState(false);
  const [reportPostOpen, setReportPostOpen] = useState(false);

  const postCardOptionsRef = useRef<HTMLDivElement>(null);
  const { originalPostOfRepostClicked, originalPostClicked } =
    useContext(CenterPanelContext);
  const { processed_posts } = useAppSelector((store) => store.newsfeed);

  if (!postId) return <></>;

  const post = processed_posts[postId];
  const isARepost = getIsARepost(post.EmbedPostID);

  const onPostCardClicked = () => {
    const selectedText = window.getSelection()?.toString() ? true : false;

    if (selectedText || isOnExpandedPostView) return;
    if (isWithinRepostPost) {
      originalPostOfRepostClicked(postId);
      return;
    }
    if (isARepost) {
      originalPostOfRepostClicked(post?.EmbedPostID);
      return;
    }
    originalPostClicked(postId);
  };

  return (
    <PostCardContext.Provider
      key={`${postId}-${isWithinRepostPost}-${isOnExpandedPostView}`}
      value={{
        showPostCardOptions,
        setShowPostCardOptions,
        postCardOptionsRef,
        reportPostOpen,
        setReportPostOpen,
        postId,
        isWithinRepostModal,
        isWithinRepostPost,
        isOnExpandedPostView,
        onPostCardClicked,
      }}
    >
      {isOnExpandedPostView ? (
        <ExpandedPostCardContentView />
      ) : (
        <DefaultPostCardContentView />
      )}
      <ReportPost />
    </PostCardContext.Provider>
  );
};
